export default {
  "regions": [
    {
      "id": 1,
      "name": "Amazonas",
      "count": 1
    },
    {
      "id": 2,
      "name": "Ancash",
      "count": 0
    },
    {
      "id": 3,
      "name": "Apurímac",
      "count": 0
    },
    {
      "id": 4,
      "name": "Arequipa",
      "count": 0
    },
    {
      "id": 5,
      "name": "Ayacucho",
      "count": 1
    },
    {
      "id": 6,
      "name": "Cajamarca",
      "count": 0
    },
    {
      "id": 7,
      "name": "Cusco",
      "count": 1
    },
    {
      "id": 8,
      "name": "Huancavelica",
      "count": 1
    },
    {
      "id": 9,
      "name": "Huánuco",
      "count": 0
    },
    {
      "id": 10,
      "name": "Ica",
      "count": 1
    },
    {
      "id": 11,
      "name": "Junín",
      "count": 0
    },
    {
      "id": 12,
      "name": "La Libertad",
      "count": 0
    },
    {
      "id": 13,
      "name": "Lambayeque",
      "count": 0
    },
    {
      "id": 14,
      "name": "Lima",
      "count": 1
    },
    {
      "id": 15,
      "name": "Loreto",
      "count": 0
    },
    {
      "id": 16,
      "name": "Madre de Dios",
      "count": 0
    },
    {
      "id": 17,
      "name": "Moquegua",
      "count": 1
    },
    {
      "id": 18,
      "name": "Pasco",
      "count": 0
    },
    {
      "id": 19,
      "name": "Piura",
      "count": 0
    },
    {
      "id": 20,
      "name": "Puno",
      "count": 0
    },
    {
      "id": 21,
      "name": "San Martin",
      "count": 0
    },
    {
      "id": 22,
      "name": "Tacna",
      "count": 0
    },
    {
      "id": 23,
      "name": "Tumbes",
      "count": 0
    },
    {
      "id": 24,
      "name": "Ucayali",
      "count": 0
    }
  ]
}